
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminDashboard: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Admin Dashboard - OGMAI</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
        <p className="text-muted-foreground">Welcome to the admin dashboard.</p>
      </div>
    </>
  );
};

export default AdminDashboard;
